import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { cn } from '../cn';

import type { NavEntry } from './types';

interface Props {
  entry: NavEntry;
  collapsed: boolean;
}

export function SidebarLink({ entry, collapsed }: Props): JSX.Element {
  const { t } = useTranslation();
  const Icon = entry.icon;
  const label = t(entry.labelKey);

  return (
    <NavLink
      to={entry.to ?? ''}
      end={entry.end ?? entry.to === ''}
      title={collapsed ? label : undefined}
      data-testid={`nav-${entry.id}`}
      className={({ isActive }) =>
        cn(
          'group relative flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors',
          collapsed && 'justify-center',
          isActive
            ? 'bg-primary/10 font-medium text-foreground'
            : 'text-muted-foreground hover:bg-muted hover:text-foreground',
        )
      }
    >
      {({ isActive }) => (
        <>
          <span
            aria-hidden="true"
            className={cn(
              'pointer-events-none absolute inset-y-1 start-0 w-1 rounded-e bg-primary transition-opacity',
              isActive ? 'opacity-100' : 'opacity-0',
            )}
          />
          <Icon size={18} className="shrink-0" />
          {collapsed ? null : <span className="truncate">{label}</span>}
        </>
      )}
    </NavLink>
  );
}
